import moment from 'moment';
import 'moment/locale/ru';
import CheckInDateRangeFactory from '../Factory/CheckInDateRange';
import TourCriteriaFactory from '../Factory/TourCriteria';
import SearchRequestFactory from '../Factory/SearchRequest';
import trackingService from './tracking/tracking';

const FinishSearchWithEmptySerpService = function (searchService, controller, searchCache, options = {}) {
    this.searchService = searchService;
    this.controller = controller;
    this.searchCache = searchCache;
    this.productType = options.productType;
};

FinishSearchWithEmptySerpService.prototype.searchFinished = function (value) {
    const self = this;
    const { controller } = this;
    const minPriceDate = controller.priceCalendar?.getMinPriceDate();
    const to = controller.view.model.get('searchData')?.get('checkInDateRange')?.get('to')?.getTime();
    let threeDaysSearch = false;
    const from = controller.view.model.get('searchData')?.get('checkInDateRange')?.get('from').getTime();
    const tourCriteriaForAsyncWithoutTours = controller.view.model.get('searchData').clone();

    const covidBanner = controller.view.model.get('covidBanner');

    if (covidBanner) return;

    if (value === 'finished' && !controller.view.model.get('additionalSearch')) {
        if (!controller.view.model.get('syncHotels') || !controller.view.model.get('syncHotels').length) {
            console.warn('Поиск не дал результатов');
            controller.view.model.trigger('setStopAlternativeSearch');
            if (from === to) {
                // устанавливаем дату по которой нет туров для отображения на календаре
                controller.priceCalendar?.setDateNotTours(moment(controller.view.model.get('searchData').get('checkInDateRange').get('to').getTime()).format('YYYY-MM-DD'));
            } else {
                threeDaysSearch = true; // поиск по -+ 3 дня
            }
            controller.noToursBanner.showBanner(controller.priceCalendar?.getMinPriceDate());

            if (controller.view.model.get('goSearchEmptySerpFoundByAnotherDate')) {
                //Поиск по минимальной дате календаря недал результатов
                controller.view.model.set('goSearchEmptySerpFoundByAnotherDate', false);
                controller.view.model.set('callMeBackBannerVisible', true);
                console.warn('Поиск по минимальной дате календаря недал результатов');
            } else if (controller.view.model.get('searchByDefaultTourCriteria')) {
                //закончился поиск по дефолтным данным - пустой
                console.warn('закончился поиск по дефолтным данным - пустой');
                controller.view.model.set('searchByDefaultTourCriteria', false);
                controller.view.model.set('callMeBackBannerVisible', true);
                if (controller.view.model.get('filteredSimilarHotels') && controller.view.model.get('filteredSimilarHotels').length) {
                    controller.view.model.set('visibleSimilarTours', defaultTourCriteriaText());
                }
            } else if (minPriceDate) {
                startSearchCalendarMinPrice(minPriceDate);
            } else {
                console.warn('Нет цены по календарю');
                if (threeDaysSearch) {
                    //запускаем посик по дефолтным критериям
                    startSearchByDefaultTourCriteria();
                } else {
                    // запускаем поиск на +-1 day
                    console.warn('запускаем поиск на +-1 day');
                    const checkInDateRange = CheckInDateRangeFactory({
                        from: controller.view.model.get('searchData').get('checkInDateRange').get('to'),
                        daysFlexible: 1,
                    });
                    tourCriteriaForAsyncWithoutTours.set('checkInDateRange', checkInDateRange);
                    controller.view.model.set({
                        additionalSearch: true,
                        loadingState: 'loading',
                    });
                    self.controller.progressBar.reset();
                    self.controller.progressBar.moveToValue(95);

                    trackNewSearchQuery('async');
                    trackingService.trackStartEmptySearch({
                        tourCriteria: tourCriteriaForAsyncWithoutTours,
                        timestamp: (new Date()).getTime(),
                        productType: this.productType,
                    });
                    self.searchService.getOffersData({
                        searchUuid: trackingService.getSearchUuid(),
                        originalSearchUuid: trackingService.originalSearchUuid,
                        requests: [new SearchRequestFactory(tourCriteriaForAsyncWithoutTours, 'asyncWithoutTours')],
                        callback: {
                            success() {
                                console.warn('запрос в прайстатистик');
                                // запрос на данные календаря в кеш (прайстатистик)
                                trackNewSearchQuery('price statistics');
                                self.controller.progressBar.moveToValue(99);
                                if (controller.priceCalendar) {
                                    controller.priceCalendar.getCalendarData({
                                        searchData: tourCriteriaForAsyncWithoutTours,
                                        notCenterCurrent: true,
                                        notClearCalendarDate: true,
                                        slideMoveDates: {
                                            from: moment(checkInDateRange.get('from')).toDate(),
                                            to: moment(checkInDateRange.get('to')).toDate(),
                                        },
                                    }, callbackAsyncSearch);
                                } else {
                                    callbackAsyncSearch();
                                }
                            },
                            error: () => {
                                loadersHide();
                            },
                        },
                        urls: _.isObject(self.searchCache) ? self.searchCache : null,
                    });
                }
            }
        }
        if (controller.view.model.get('syncHotels') && controller.view.model.get('syncHotels').length && controller.view.model.get('minPrice') < Infinity && (to === from) && !controller.view.model.get('visibleSimilarTours')) {
            if (_.isFunction(controller.priceCalendar?.addCalendarData)) {
                controller.priceCalendar?.addCalendarData({
                    date: moment(from),
                    price: controller.view.model.get('minPrice'),
                });
            }
        }
    }

    if (controller.view.model.get('syncHotels') && controller.view.model.get('syncHotels').length) {
        if (controller.view.model.get('goSearchEmptySerpFoundByAnotherDate')) {
            if (minPriceDate) {
                //Поиск по минимальной дате успешен
                console.warn('Поиск по минимальной дате успешен - показываем выдачу, поиск продолжается');
                controller.view.model.set('foundByAnotherDate', minPriceDate.format('DD MMMM'));
                controller.view.model.set('goSearchEmptySerpFoundByAnotherDate', false);
                controller.priceCalendar?.setActiveCollByDateStr(minPriceDate.format('YYYY-MM-DD'));

                controller.priceCalendar?.renderSlider({ lastCollIndex: 23 });
            }
        }
        if (controller.view.model.get('searchByDefaultTourCriteria')) {
            controller.view.model.set('visibleSimilarTours', defaultTourCriteriaText());
            controller.view.model.set('searchByDefaultTourCriteria', false);
            controller.view.model.set('callMeBackBannerVisible', true);
            console.warn('поиск по дефолтным данным - есть результат');
        }
    }

    function startSearchByDefaultTourCriteria() {
        self.tourCriteriaForSearchByDefaultsCriteria = self.generateDefaultsTourCriteria(tourCriteriaForAsyncWithoutTours);
        controller.view.model.set('searchByDefaultTourCriteria', true);
        console.warn('запускаем посик по дефолтным критериям');
        trackNewSearchQuery('async');
        controller.goSearch(self.tourCriteriaForSearchByDefaultsCriteria, {
            additionalSearch: true,
        });
    }

    function callbackAsyncSearch(calendarData) {
        // дергаем календарь на минимальную цену
        console.warn(calendarData);
        console.warn('дергаем календарь на минимальную цену');
        self.controller.progressBar.moveToValue(85);
        if (controller.priceCalendar?.getMinPriceDate()) {
            // если есть цена то запрос в кеш на выдачу по этой дате с календаря
            console.warn('запрос в кеш на выдачу по этой дате с календаря');
            startSearchCalendarMinPrice(controller.priceCalendar?.getMinPriceDate());
        } else {
            console.warn('минимальная цена не пришла');
            loadersHide();
            startSearchByDefaultTourCriteria();
        }
    }
    function loadersHide() {
        self.controller.progressBar.complete();
        controller.view.model.set('loadingState', 'finished');
        controller.view.model.set('additionalSearch', false);
    }

    function startSearchCalendarMinPrice(minPriceDate) {
        // Старт поиска по минимальной дате календаря
        console.warn('Старт поиска по минимальной дате календаря');
        trackNewSearchQuery('async');
        controller.view.model.set('goSearchEmptySerpFoundByAnotherDate', true);
        controller.priceCalendar?.startNewSearchByDate(minPriceDate, true);
    }

    function defaultTourCriteriaText() {
        let text = '';
        const tourCriteria = self.tourCriteriaForSearchByDefaultsCriteria;
        const touristGroup = tourCriteria.get('touristGroup').toJSON();
        touristGroup.babies = touristGroup.kids + touristGroup.infants;
        text += `${tourCriteria.get('countries').models[0].get('name')}, c `;
        text += `${moment(tourCriteria.get('checkInDateRange').get('from')).format('DD.MM.YYYY')} на `;
        text += `${tourCriteria.get('nightRange').get('from')} - ${tourCriteria.get('nightRange').get('to')} ночей и `;
        text += `${touristGroup.adults} ${touristGroup.adults.wordEnding('взрослый;взрослых;взрослых')}`;
        if (touristGroup.babies) {
            text += ` c ${touristGroup.babies} ${touristGroup.babies.wordEnding('ребенок;детьми;детьми')}`;
        }
        return text;
    }

    function trackNewSearchQuery(text) {
        /*if(typeof trackJs !== 'undefined'){
            trackJs.track("new search query was empty SERP: " + (text || ''));
        }*/
    }
};

FinishSearchWithEmptySerpService.prototype.generateDefaultsTourCriteria = function (tourCriteriaForAsyncWithoutTours) {
    const { controller } = this;
    const defaultTourCriteria = controller.view.model.get('searchData').get('countries').at(0).get(`${controller.view.model.get('searchData').get('departureCity').get('type')}TourCriteria`);
    const countries = [tourCriteriaForAsyncWithoutTours.get('countries').models[0].get('id')];
    const departureCity = tourCriteriaForAsyncWithoutTours.get('departureCity');
    const touristGroup = tourCriteriaForAsyncWithoutTours.get('touristGroup').toJSON();

    return new TourCriteriaFactory(_.extend({}, defaultTourCriteria, {
        countries,
        departureCity,
        touristGroup,
    }));
};

export default FinishSearchWithEmptySerpService;